// "Undo before sending" (Settings, Gary 16 Oct): a typed reply to a customer waits a few
// seconds with an Undo button before it goes to WhatsApp, which cannot unsend. Remembered on
// this device; on unless switched off, for people who chat fast.

const KEY = 'chats.undoSend';
export const UNDO_SECONDS = 5;

export function readUndoSend(): boolean {
  try { return localStorage.getItem(KEY) !== '0'; } catch { return true; }
}

export function writeUndoSend(on: boolean): void {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* storage blocked: holds for this visit */ }
}
